import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postShareVariant = createApi("PostShareVariantSlice", 'POST');

const PostShareVariantSlice = createSlice({
  name: 'PostShareVariantSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postShareVariant.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postShareVariant.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postShareVariant.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostShareVariantSlice.reducer;